export default __webpack_public_path__ + "static/minnesota-hvac-company-067edf6c4fb5364ab35d342fc4dfd879.png";